import { motion } from "motion/react";
import Header from "../../../components/feature/Header";
import Footer from "../../../components/feature/Footer";
import WhatsAppFloating from "../../../components/feature/WhatsAppFloating";
import CookieBanner from "../../../components/feature/CookieBanner";
import QuoteFormSection from "../../home/components/QuoteFormSection";
import SEO from "@/components/feature/SEO";

const brazos = [
  {
    icon: "ri-eye-off-line",
    title: "Brazo invisible",
    desc: "Los brazos se esconden dentro de la fachada o en guías ocultas. Máxima estética para fachadas modernas.",
    best: "Fachadas nuevas, diseño minimalista",
  },
  {
    icon: "ri-scissors-cut-line",
    title: "Brazo articulado clásico",
    desc: "El sistema más popular y económico. Brazos articulados visibles, robustos y de fácil mantenimiento.",
    best: "Terrazas, porches, hogares",
  },
  {
    icon: "ri-expand-horizontal-line",
    title: "Brazo de tijera",
    desc: "Para grandes superficies y cargas pesadas. Distribuye el peso uniformemente en toldos de hostelería.",
    best: "Restaurantes, terrazas XL, comercios",
  },
];

const aplicaciones = [
  { emoji: "🏠", title: "Terrazas medianas y grandes", desc: "De 3 a 6 metros de ancho. Cubrimos tu terraza completa con sombra a medida." },
  { emoji: "🏡", title: "Porches residenciales", desc: "Toldos que se integran perfectamente en porches ya existentes o nuevos." },
  { emoji: "🏙️", title: "Áticos con vistas", desc: "Brazos invisibles o bajos para no obstaculizar la panorámica." },
  { emoji: "🍽️", title: "Restaurantes y bares", desc: "Soportes reforzados, lonas ignífugas y grandes dimensiones para hostelería." },
];

const precios = [
  { tipo: "Extensible 3x2m", precio: "600 - 900 €" },
  { tipo: "Extensible 4x3m manual", precio: "900 - 1.300 €" },
  { tipo: "Extensible 5x3m motorizado", precio: "1.500 - 2.200 €" },
  { tipo: "Extensible XL hostelería 6x4m", precio: "2.500 - 4.000 €" },
];

const faqs = [
  {
    q: "¿Qué tamaño máximo tienen los toldos extensibles?",
    a: "Fabricamos toldos extensibles de hasta 7 metros de ancho por 4 metros de proyección. Para medidas superiores te recomendamos pérgolas o toldos de doble pendiente. La visita es gratuita para evaluar tu espacio.",
  },
  {
    q: "¿Resisten el viento de Málaga?",
    a: "Sí. Usamos brazos de aluminio reforzado y lonas técnicas resistentes al viento. Para zonas muy ventosas recomendamos sensor de viento Somfy que recoge el toldo automáticamente si sopla fuerte.",
  },
  {
    q: "¿Se puede instalar en cualquier fachada?",
    a: "Casi todas. Evaluamos la fachada en la visita gratuita. Si la pared no tiene suficiente resistencia, instalamos una placa de anclaje o usamos soportes especiales sin problema.",
  },
  {
    q: "¿Necesito permiso de comunidad?",
    a: "Para instalaciones en fachadas exteriores de edificios de comunidad, normalmente sí es necesario informar o pedir permiso. Te asesoramos en el proceso y te damos el documento técnico que necesites.",
  },
  {
    q: "¿Pueden ser motorizados?",
    a: "Sí, todos nuestros toldos extensibles se pueden motorizar con motor tubular Somfy. Añade comodidad: sube y baja el toldo desde el sofá o programa horarios automáticos.",
  },
];

export default function ToldosExtensibles() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Toldos Extensibles Málaga | Brazos Articulados Pro"
        description="Toldos extensibles en Málaga para terrazas y porches. Brazos articulados o invisibles. Instalación profesional. ☎ 951 12 07 70"
        canonical="/toldos/toldos-extensibles/"
        breadcrumbs={[{ name: "Inicio", path: "/" }, { name: "Toldos", path: "/toldos" }, { name: "Toldos extensibles" }]}
      />
      <Header />
      <main>
        {/* HERO */}
        <section className="bg-white pt-24 md:pt-[72px]">
          <div className="max-w-container mx-auto px-4 md:px-6 py-12 md:py-24">
            <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
              <div className="w-full lg:w-[60%] flex flex-col gap-6">
                <div className="inline-flex items-center gap-2 bg-accent text-text-primary font-body font-semibold text-sm px-4 py-2 rounded-pill w-fit">
                  <span>⚡</span> Sombra a medida
                </div>
                <h1 className="font-heading font-extrabold text-4xl md:text-5xl lg:text-[56px] leading-[1.1] text-text-primary">
                  Toldos Extensibles en Málaga: Sombra a Medida
                </h1>
                <p className="font-body text-lg md:text-xl text-text-secondary leading-relaxed max-w-xl">
                  Toldos de brazos extensibles para terrazas y porches. Versatilidad y elegancia.
                </p>
                <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
                  <a
                    href="tel:+34951120770"
                    className="inline-flex items-center gap-2 bg-primary hover:bg-primary-dark text-white font-body font-bold text-lg md:text-xl px-8 py-4 rounded-pill transition-colors whitespace-nowrap"
                  >
                    <span>📞</span> 951 12 07 70
                  </a>
                  <a
                    href="#presupuesto"
                    className="inline-flex items-center gap-2 border-2 border-secondary text-secondary hover:bg-secondary hover:text-white font-body font-semibold text-base px-6 py-3.5 rounded-pill transition-colors whitespace-nowrap"
                  >
                    Pedir presupuesto
                  </a>
                </div>
                <div className="flex flex-wrap items-center gap-4 md:gap-6 mt-2">
                  <span className="flex items-center gap-1.5 font-body font-medium text-sm text-text-secondary"><span className="text-green-600">✓</span> +10 años · desde 2015</span>
                  <span className="flex items-center gap-1.5 font-body font-medium text-sm text-text-secondary"><span className="text-green-600">✓</span> Seguro RC</span>
                  <span className="flex items-center gap-1.5 font-body font-medium text-sm text-text-secondary"><span className="text-green-600">✓</span> Garantía 2 años</span>
                </div>
              </div>
              <div className="w-full lg:w-[40%] relative">
                <div className="relative rounded-3xl overflow-hidden lg:-rotate-1 shadow-xl">
                  <div className="absolute inset-0 bg-blue-900/35 z-10 pointer-events-none"></div>
                  <img
                    src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1200&q=80&auto=format&fit=crop"
                    alt="Toldos extensibles en Málaga - brazos articulados para terrazas"
                    className="w-full h-auto object-cover aspect-[4/3]"
                    loading="eager"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ¿CÓMO FUNCIONAN? */}
        <section className="bg-surface-alt py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="max-w-3xl mx-auto text-center">
              <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary mb-4">¿Cómo funcionan?</h2>
              <div className="w-10 h-1 bg-primary mx-auto rounded-full mb-6"></div>
              <p className="font-body text-lg text-text-secondary leading-relaxed">
                Los toldos extensibles usan <strong className="text-text-primary">brazos articulados</strong> que se extienden desde la fachada hacia el exterior. Cuando bajas el toldo, los brazos se despliegan manteniendo la lona tensa y plana. Al recogerlo, los brazos se pliegan sobre sí mismos y la lona se enrolla en la barra superior. Es el sistema más versátil: cubre terrazas, porches, áticos y espacios comerciales con elegancia.
              </p>
            </div>
          </div>
        </section>

        {/* TIPOS DE BRAZOS */}
        <section className="bg-white py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary text-center mb-12">Tipos de brazos</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
              {brazos.map((b, i) => (
                <motion.div
                  key={b.title}
                  className="bg-surface-alt rounded-[20px] p-8 border-t-[6px] border-secondary shadow-sm hover:shadow-md transition-shadow"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.1 }}
                >
                  <div className="w-12 h-12 bg-secondary/10 text-secondary rounded-xl flex items-center justify-center mb-5">
                    <i className={`${b.icon} text-2xl`}></i>
                  </div>
                  <h3 className="font-heading font-bold text-xl text-text-primary mb-2">{b.title}</h3>
                  <p className="font-body text-sm text-text-secondary mb-4 leading-relaxed">{b.desc}</p>
                  <div className="inline-block bg-secondary/10 text-secondary font-body font-semibold text-xs px-3 py-1.5 rounded-pill">
                    Ideal: {b.best}
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* APLICACIONES */}
        <section className="bg-surface-alt py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary text-center mb-12">Aplicaciones ideales</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {aplicaciones.map((a, i) => (
                <motion.div
                  key={a.title}
                  className="bg-white rounded-[20px] p-8 shadow-sm hover:shadow-md transition-shadow text-center"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.1 }}
                >
                  <div className="text-4xl mb-4">{a.emoji}</div>
                  <h3 className="font-heading font-bold text-lg text-text-primary mb-2">{a.title}</h3>
                  <p className="font-body text-sm text-text-secondary leading-relaxed">{a.desc}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* PRECIOS */}
        <section className="bg-white py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary text-center mb-4">Precios orientativos</h2>
            <p className="font-body text-lg text-text-secondary text-center mb-10 max-w-2xl mx-auto">
              Precios según dimensiones, tipo de brazo, motorización y lona. Todos incluyen instalación y garantía de 2 años.
            </p>
            <div className="max-w-2xl mx-auto bg-surface-alt rounded-3xl overflow-hidden">
              {precios.map((p, i) => (
                <div
                  key={p.tipo}
                  className={`flex items-center justify-between px-6 md:px-8 py-5 ${i !== precios.length - 1 ? "border-b border-border" : ""}`}
                >
                  <span className="font-body text-base md:text-lg text-text-primary">{p.tipo}</span>
                  <span className="font-heading font-bold text-lg md:text-xl text-primary">{p.precio}</span>
                </div>
              ))}
            </div>
            <p className="text-center font-body text-sm text-text-secondary mt-6">
              Precios orientativos. Presupuesto exacto sin compromiso tras visita técnica.
            </p>
          </div>
        </section>

        {/* FAQ */}
        <section className="bg-surface-alt py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="max-w-3xl mx-auto" itemScope itemType="https://schema.org/FAQPage">
              <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary text-center mb-12">Preguntas frecuentes sobre toldos extensibles</h2>
              <div className="flex flex-col gap-4">
                {faqs.map((f, i) => (
                  <motion.div
                    key={i}
                    className="bg-white rounded-2xl p-6 shadow-sm"
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.4, delay: i * 0.08 }}
                    itemScope
                    itemProp="mainEntity"
                    itemType="https://schema.org/Question"
                  >
                    <h3 className="font-heading font-bold text-lg text-text-primary mb-2" itemProp="name">{f.q}</h3>
                    <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
                      <p className="font-body text-sm text-text-secondary leading-relaxed" itemProp="text">{f.a}</p>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* FORM */}
        <div id="presupuesto">
          <QuoteFormSection />
        </div>
      </main>
      <Footer />
      <WhatsAppFloating />
      <CookieBanner />
    </div>
  );
}